import React, { memo, useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { usePatchRequest } from '../../../hooks/usePatchRequest';
import { fontSizeOptions } from '../../../utils/helpers';

const PatientSettingForm = ({
  patientItemSetting,
  patientItems,
  handlePatientItemSetting,
  isPatientSettingModal,
  closePatientSettingModal,
}) => {
  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (
      patientItemSetting?.name === 'age' &&
      !patientItemSetting.hasOwnProperty('unitProperties')
    ) {
      patientItemSetting['unitProperties'] = defaultUnitProperties();
      handlePatientItemSetting(patientItemSetting);
    }
  }, [patientItemSetting]);

  const defaultUnitProperties = () => {
    return {
      years: { label: 'Years', enabled: true },
      months: { label: 'Months', enabled: false },
      days: { label: 'Days', enabled: false },
      hours: { label: 'Hours', enabled: false },
    };
  };

  const { isLoading: isLoadingPatientPost, mutate: submitPatientPrintSetting } =
    usePatchRequest(
      'settings/prescription-patient-item-setting',
      {
        organizationId: activeOrganization.id,
        items: patientItems,
      },
      (res) => {
        closePatientSettingModal(false);
        toast.success('Updated successfully', {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
      (e) => {
        toast.error(e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
    );
  const handleSubmit = () => {
    submitPatientPrintSetting();
  };
  const getErrorMessage = (inputName) => {
    return errors[inputName] ? errors[inputName] : '';
  };

  // const handlePatientInputSetting = (
  //   fieldType,
  //   properties,
  //   type,
  //   fieldName,
  //   value,
  // ) => {
  //   console.log(fieldType, properties, type, fieldName, value, 'testdata');

  //   if (fieldType === 'label' || fieldType === 'value') {
  //     if (fieldName === 'isHidden' || type === 'labelValue') {
  //       patientItemSetting[fieldType][properties][fieldName] = value;
  //     } else {
  //       patientItemSetting[fieldType][properties][type][fieldName] = value;
  //     }
  //   } else if (fieldName === 'labelName') {
  //     patientItemSetting['label'][fieldName] = value;
  //   } else {
  //     patientItemSetting[fieldName] = value;
  //   }
  //   handlePatientItemSetting(patientItemSetting);
  // };

  const handlePatientInputSetting = (
    fieldType,
    properties,
    type,
    fieldName,
    value,
  ) => {
    const resetTextStyles = (target: any) => {
      target.capitalize = false;
      target.uppercase = false;
      target.lowercase = false;
    };

    if (fieldType === 'label' || fieldType === 'value') {
      if (fieldName === 'isHidden') {
        patientItemSetting[fieldType][properties][fieldName] = value;
      } else if (type === 'labelValue') {
        const target = patientItemSetting[fieldType][properties];
        if (
          fieldName === 'capitalize' ||
          fieldName === 'uppercase' ||
          fieldName === 'lowercase'
        ) {
          resetTextStyles(target);
        }
        target[fieldName] = value;
      } else {
        patientItemSetting[fieldType][properties][type][fieldName] = value;
      }
    } else if (fieldName === 'labelName') {
      patientItemSetting.label[fieldName] = value;
    } else {
      patientItemSetting[fieldName] = value;
    }

    handlePatientItemSetting(patientItemSetting);
  };

  const handleAgeUnit = (rowName, fieldName, value) => {
    patientItemSetting.unitProperties[rowName][fieldName] = value;
    handlePatientItemSetting(patientItemSetting);
  };

  const fontFamilies = [
    'Times New Roman',
    'Calibri',
    'Verdana',
    'Arial',
    'Arial Narrow',
    'Arial Black',
    'Courier New',
    'Georgia',
    'Roboto',
    'Snell Roundhand Script',
    'Helvetica',
    'Comic Sans MS',
    'Montserrat',
    'Lora',
  ];

  const banglaFontFamilies = [
    'Kalpurush',
    'SolaimanLipi',
    'Nikosh',
    'Siyam Rupali',
    'AdorshoLipi',
    'Likhan',
    'BenSen Handwriting',
    'Mukti',
  ];

  const clearData = (fieldType) => {
    patientItemSetting[fieldType].properties.capitalize = false;
    patientItemSetting[fieldType].properties.uppercase = false;
    patientItemSetting[fieldType].properties.lowercase = false;

    handlePatientItemSetting(patientItemSetting);
  };

  return (
    <>
      <Modal show={isPatientSettingModal} size="lg">
        <Modal.Header className="common-modal-header">
          <Col className="pl-0">
            <Modal.Title>Patient Setting</Modal.Title>
          </Col>
          <Col md={1} style={{ textAlign: 'end' }}>
            <i
              onClick={() => closePatientSettingModal()}
              className="far fa-times-circle "
              aria-hidden="true"
            ></i>
          </Col>
        </Modal.Header>
        <Modal.Body className="pb-2">
          <Form>
            <Row>
              <Col>
                Field Name:{' '}
                <b>
                  {patientItemSetting.name} {patientItemSetting?.isHidden}
                </b>
              </Col>
              <Col className="text-right">
                <Form.Check
                  inline
                  label=" Is Hide In Input?"
                  name="page-border"
                  type={'checkbox'}
                  checked={!patientItemSetting?.isHideInInput === false}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      '',
                      '',
                      '',
                      'isHideInInput',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col className="text-right">
                <Form.Check
                  inline
                  label=" Is Hide In Print?"
                  name="page-border"
                  type={'checkbox'}
                  checked={!patientItemSetting?.isHidden === false}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      '',
                      '',
                      '',
                      'isHidden',
                      e.target.checked,
                    )
                  }
                />
              </Col>
            </Row>
            <hr className="custom-hr" />
            <Row className="align-items-center mb-2">
              <Col md={4}>
                <Form.Group
                  as={Row}
                  controlId="width"
                  className="align-items-center"
                >
                  <Form.Label column sm="3">
                    Width
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={patientItemSetting?.width}
                      onChange={(e) =>
                        handlePatientInputSetting(
                          '',
                          '',
                          '',
                          'width',
                          e.target.value,
                        )
                      }
                    />
                    <small className="v-error">
                      {getErrorMessage('brandName')}
                    </small>
                  </Col>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group
                  as={Row}
                  controlId="unit"
                  className="align-items-center"
                >
                  <Form.Label column sm="2">
                    Unit
                  </Form.Label>
                  <Col sm="10">
                    <Form.Select
                      className="form-control form-control-sm"
                      defaultValue={patientItemSetting?.unit}
                      onChange={(e) =>
                        handlePatientInputSetting(
                          '',
                          '',
                          '',
                          'unit',
                          e.target.value,
                        )
                      }
                    >
                      <option value="cm">cm</option>
                      <option value="px">px</option>
                      <option value="in">inches</option>
                      <option value="%">%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group
                  as={Row}
                  controlId="row"
                  className="align-items-center"
                >
                  <Form.Label column sm="2">
                    Row
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      readOnly
                      defaultValue={patientItemSetting?.rowNumber}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <hr className="custom-hr" />
            <h4>Label Properties</h4>
            <hr className="custom-hr" />
            <Row>
              <Col>
                <Form.Group as={Row} controlId="width">
                  <Form.Label column sm="4">
                    Label Name
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={patientItemSetting?.label?.labelName}
                      onChange={(e) =>
                        handlePatientInputSetting(
                          '',
                          '',
                          '',
                          'labelName',
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col md={1}></Col>
                </Form.Group>
              </Col>
              <Col className="text-right">
                <Form.Check
                  inline
                  label=" Is Hide In Print ?"
                  name="page-border"
                  type={'checkbox'}
                  checked={
                    !patientItemSetting?.label?.properties?.isHidden === false
                  }
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      '',
                      'isHidden',
                      e.target.checked,
                    )
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group as={Row} controlId="width">
                  <Form.Label column sm="4">
                    Padding Top
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={
                        patientItemSetting?.label?.properties?.paddingTop
                          ?.quantity
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'label',
                          'properties',
                          'paddingTop',
                          'quantity',
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col sm="3" className="pl-0">
                    <Form.Select
                      className="form-control form-control-sm"
                      defaultValue={
                        patientItemSetting?.label?.properties?.paddingTop?.unit
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'label',
                          'properties',
                          'paddingTop',
                          'unit',
                          e.target.value,
                        )
                      }
                    >
                      <option value="cm">cm</option>
                      <option value="px">px</option>
                      <option value="in">inches</option>
                      <option value="%">%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group as={Row} controlId="width">
                  <Form.Label column sm="5" className="text-right">
                    Padding Bottom
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={
                        patientItemSetting?.label?.properties?.paddingBottom
                          ?.quantity
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'label',
                          'properties',
                          'paddingBottom',
                          'quantity',
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col sm="3" className="pl-0">
                    <Form.Select
                      className="form-control form-control-sm"
                      defaultValue={
                        patientItemSetting?.label?.properties?.paddingBottom
                          ?.unit
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'label',
                          'properties',
                          'paddingBottom',
                          'unit',
                          e.target.value,
                        )
                      }
                    >
                      <option value="cm">cm</option>
                      <option value="px">px</option>
                      <option value="in">inches</option>
                      <option value="%">%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group as={Row} className="mb-1" controlId="width">
                  <Form.Label column sm="4">
                    Padding Left
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={
                        patientItemSetting?.label?.properties?.paddingLeft
                          ?.quantity
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'label',
                          'properties',
                          'paddingLeft',
                          'quantity',
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col sm="3" className="pl-0">
                    <Form.Select
                      className="form-control form-control-sm"
                      defaultValue={
                        patientItemSetting?.label?.properties?.paddingLeft?.unit
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'label',
                          'properties',
                          'paddingLeft',
                          'unit',
                          e.target.value,
                        )
                      }
                    >
                      <option value="cm">cm</option>
                      <option value="px">px</option>
                      <option value="in">inches</option>
                      <option value="%">%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group as={Row} className="mb-1" controlId="width">
                  <Form.Label column sm="5" className="text-right">
                    Padding Right
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={
                        patientItemSetting?.label?.properties?.paddingRight
                          ?.quantity
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'label',
                          'properties',
                          'paddingRight',
                          'quantity',
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col sm="3" className="pl-0">
                    <Form.Select
                      className="form-control form-control-sm"
                      defaultValue={
                        patientItemSetting?.label?.properties?.paddingRight
                          ?.unit
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'label',
                          'properties',
                          'paddingRight',
                          'unit',
                          e.target.value,
                        )
                      }
                    >
                      <option value="cm">cm</option>
                      <option value="px">px</option>
                      <option value="in">inches</option>
                      <option value="%">%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
            </Row>

            <hr className="custom-hr" />

            <Row>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Capitalize"
                  name="labelFontStyle"
                  type="radio"
                  checked={patientItemSetting?.label?.properties?.capitalize}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'capitalize',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Uppercase"
                  name="labelFontStyle"
                  type="radio"
                  checked={patientItemSetting?.label?.properties?.uppercase}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'uppercase',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Lowercase"
                  name="labelFontStyle"
                  type="radio"
                  checked={patientItemSetting?.label?.properties?.lowercase}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'lowercase',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={2} className="text-left">
                <Button
                  size="sm"
                  variant="outline-danger"
                  onClick={() => clearData('label')}
                >
                  Clear
                </Button>
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Bold"
                  name="labelBold"
                  type={'checkbox'}
                  checked={patientItemSetting?.label?.properties?.bold}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'bold',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Italic"
                  name="labelItalic"
                  type={'checkbox'}
                  checked={patientItemSetting?.label?.properties?.italic}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'italic',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Underline"
                  name="labelUnderline"
                  type={'checkbox'}
                  checked={patientItemSetting?.label?.properties?.underline}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'underline',
                      e.target.checked,
                    )
                  }
                />
              </Col>
            </Row>

            <hr className="custom-hr" />

            <Row className="align-items-center mb-2">
              <Col md={2}>Font Style: </Col>
              <Col>
                <Form.Select
                  className="form-control form-control-sm"
                  defaultValue={patientItemSetting?.label?.properties?.fontSize}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'fontSize',
                      e.target.value,
                    )
                  }
                >
                  {fontSizeOptions?.map((element, index) => (
                    <option key={index} value={element}>
                      {element.replace('px', '')}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col>
                <Form.Control
                  size="sm"
                  type="color"
                  placeholder="color"
                  defaultValue={patientItemSetting?.label?.properties?.color}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'color',
                      e.target.value,
                    )
                  }
                />
              </Col>
              <Col>
                <Form.Select
                  className="form-control form-control-sm"
                  defaultValue={
                    patientItemSetting?.label?.properties?.fontFamily
                  }
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'fontFamily',
                      e.target.value,
                    )
                  }
                >
                  {fontFamilies?.map((element, index) => (
                    <option key={index}>{element}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col>
                <Form.Select
                  className="form-control form-control-sm"
                  defaultValue={
                    patientItemSetting?.label?.properties?.banglaFontFamily
                  }
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'label',
                      'properties',
                      'labelValue',
                      'banglaFontFamily',
                      e.target.value,
                    )
                  }
                >
                  {banglaFontFamilies?.map((element, index) => (
                    <option key={index}>{element}</option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
            <hr className="custom-hr" />
            <h4>Value Properties</h4>
            <hr className="custom-hr" />
            <Row>
              <Col md={6}>
                <Form.Group as={Row} controlId="width">
                  <Form.Label column sm="4">
                    Padding Top
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={
                        patientItemSetting?.value?.properties?.paddingTop
                          ?.quantity
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'value',
                          'properties',
                          'paddingTop',
                          'quantity',
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col sm="3" className="pl-0">
                    <Form.Select
                      className="form-control form-control-sm"
                      defaultValue={
                        patientItemSetting?.value?.properties?.paddingTop?.unit
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'value',
                          'properties',
                          'paddingTop',
                          'unit',
                          e.target.value,
                        )
                      }
                    >
                      <option value="cm">cm</option>
                      <option value="px">px</option>
                      <option value="in">inches</option>
                      <option value="%">%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group as={Row} controlId="width">
                  <Form.Label column sm="5" className="text-right">
                    Padding Bottom
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={
                        patientItemSetting?.value?.properties?.paddingBottom
                          ?.quantity
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'value',
                          'properties',
                          'paddingBottom',
                          'quantity',
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col sm="3" className="pl-0">
                    <Form.Select
                      className="form-control form-control-sm"
                      defaultValue={
                        patientItemSetting?.value?.properties?.paddingBottom
                          ?.unit
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'value',
                          'properties',
                          'paddingBottom',
                          'unit',
                          e.target.value,
                        )
                      }
                    >
                      <option value="cm">cm</option>
                      <option value="px">px</option>
                      <option value="in">inches</option>
                      <option value="%">%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group as={Row} controlId="width">
                  <Form.Label column sm="4">
                    Padding Left
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={
                        patientItemSetting?.value?.properties?.paddingLeft
                          ?.quantity
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'value',
                          'properties',
                          'paddingLeft',
                          'quantity',
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col sm="3" className="pl-0">
                    <Form.Select
                      className="form-control form-control-sm"
                      defaultValue={
                        patientItemSetting?.value?.properties?.paddingLeft?.unit
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'value',
                          'properties',
                          'paddingLeft',
                          'unit',
                          e.target.value,
                        )
                      }
                    >
                      <option value="cm">cm</option>
                      <option value="px">px</option>
                      <option value="in">inches</option>
                      <option value="%">%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group as={Row} controlId="width">
                  <Form.Label column sm="5" className="text-right">
                    Padding Right
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      defaultValue={
                        patientItemSetting?.value?.properties?.paddingRight
                          ?.quantity
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'value',
                          'properties',
                          'paddingLeft',
                          'quantity',
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col sm="3" className="pl-0">
                    <Form.Select
                      className="form-control form-control-sm"
                      defaultValue={
                        patientItemSetting?.value?.properties?.paddingRight
                          ?.unit
                      }
                      onChange={(e) =>
                        handlePatientInputSetting(
                          'value',
                          'properties',
                          'paddingRight',
                          'unit',
                          e.target.value,
                        )
                      }
                    >
                      <option value="cm">cm</option>
                      <option value="px">px</option>
                      <option value="in">inches</option>
                      <option value="%">%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            {patientItemSetting?.name === 'age' && (
              <>
                <hr className="custom-hr" />
                <h3>Unit Properties</h3>
                <hr className="custom-hr" />
                <Row>
                  <Col md={6}>
                    <Form.Group as={Row} controlId="width">
                      <Form.Label column sm="4">
                        Years Unit{' '}
                      </Form.Label>
                      <Col sm="4">
                        <Form.Control
                          type="text"
                          className="form-control-sm"
                          defaultValue={
                            patientItemSetting?.unitProperties?.years?.label
                          }
                          onChange={(e) =>
                            handleAgeUnit('years', 'label', e.target.value)
                          }
                        />
                      </Col>
                      <Col sm="4" className="pt-1">
                        <Form.Check
                          inline
                          label="Enable?"
                          name="year-unit"
                          id="year-unit"
                          type={'checkbox'}
                          checked={
                            !patientItemSetting?.unitProperties?.years
                              ?.enabled === false
                          }
                          onChange={(e) =>
                            handleAgeUnit('years', 'enabled', e.target.checked)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group as={Row} controlId="width">
                      <Form.Label column sm="4" className="text-right">
                        Months Unit
                      </Form.Label>
                      <Col sm="4">
                        <Form.Control
                          type="text"
                          className="form-control-sm"
                          defaultValue={
                            patientItemSetting?.unitProperties?.months?.label
                          }
                          onChange={(e) =>
                            handleAgeUnit('months', 'label', e.target.value)
                          }
                        />
                      </Col>
                      <Col sm="4" className="pt-1">
                        <Form.Check
                          inline
                          label="Enable?"
                          name="month-unit"
                          id="month-unit"
                          type={'checkbox'}
                          checked={
                            !patientItemSetting?.unitProperties?.months
                              ?.enabled === false
                          }
                          onChange={(e) =>
                            handleAgeUnit('months', 'enabled', e.target.checked)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group as={Row} className="mb-3" controlId="width">
                      <Form.Label column sm="4">
                        Days Unit
                      </Form.Label>
                      <Col sm="4">
                        <Form.Control
                          type="text"
                          className="form-control-sm"
                          defaultValue={
                            patientItemSetting?.unitProperties?.days?.label
                          }
                          onChange={(e) =>
                            handleAgeUnit('days', 'label', e.target.value)
                          }
                        />
                      </Col>
                      <Col sm="3" className="pt-1">
                        <Form.Check
                          inline
                          label="Enable?"
                          name="days-unit"
                          id="days-unit"
                          type={'checkbox'}
                          checked={
                            !patientItemSetting?.unitProperties?.days
                              ?.enabled === false
                          }
                          onChange={(e) =>
                            handleAgeUnit('days', 'enabled', e.target.checked)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group as={Row} className="mb-3" controlId="width">
                      <Form.Label column sm="4" className="text-right">
                        Hours Unit
                      </Form.Label>
                      <Col sm="4">
                        <Form.Control
                          type="text"
                          className="form-control-sm"
                          defaultValue={
                            patientItemSetting?.unitProperties?.hours?.label
                          }
                          onChange={(e) =>
                            handleAgeUnit('hours', 'label', e.target.value)
                          }
                        />
                      </Col>
                      <Col sm="4" className="pt-1">
                        <Form.Check
                          inline
                          label="Enable?"
                          name="hour-unit"
                          id="hour-unit"
                          type={'checkbox'}
                          checked={
                            !patientItemSetting?.unitProperties?.hours
                              ?.enabled === false
                          }
                          onChange={(e) =>
                            handleAgeUnit('hours', 'enabled', e.target.checked)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            <hr className="custom-hr" />

            <Row>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Capitalize"
                  name="valueFontStyle"
                  type="radio"
                  checked={patientItemSetting?.value?.properties?.capitalize}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'capitalize',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Uppercase"
                  name="valueFontStyle"
                  type="radio"
                  checked={patientItemSetting?.value?.properties?.uppercase}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'uppercase',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Lowercase"
                  name="valueFontStyle"
                  type="radio"
                  checked={patientItemSetting?.value?.properties?.lowercase}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'lowercase',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={2} className="text-left">
                <Button
                  size="sm"
                  variant="outline-danger"
                  onClick={() => clearData('value')}
                >
                  Clear
                </Button>
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Bold"
                  name="valueBold"
                  type={'checkbox'}
                  checked={patientItemSetting?.value?.properties?.bold}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'bold',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Italic"
                  name="valueItalic"
                  type={'checkbox'}
                  checked={patientItemSetting?.value?.properties?.italic}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'italic',
                      e.target.checked,
                    )
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  inline
                  label="Underline"
                  name="valueUnderline"
                  type={'checkbox'}
                  checked={patientItemSetting?.value?.properties?.underline}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'underline',
                      e.target.checked,
                    )
                  }
                />
              </Col>
            </Row>

            <hr className="custom-hr" />

            <Row className="align-items-center mb-2">
              <Col md={2}>Font Style: </Col>
              <Col>
                <Form.Select
                  className="form-control form-control-sm"
                  defaultValue={patientItemSetting?.value?.properties?.fontSize}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'fontSize',
                      e.target.value,
                    )
                  }
                >
                  {fontSizeOptions?.map((element, index) => (
                    <option key={index} value={element}>
                      {element.replace('px', '')}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col>
                <Form.Control
                  size="sm"
                  type="color"
                  placeholder="color"
                  defaultValue={patientItemSetting?.value?.properties?.color}
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'color',
                      e.target.value,
                    )
                  }
                />
              </Col>
              <Col>
                <Form.Select
                  className="form-control form-control-sm"
                  defaultValue={
                    patientItemSetting?.value?.properties?.fontFamily
                  }
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'fontFamily',
                      e.target.value,
                    )
                  }
                >
                  {fontFamilies?.map((element, index) => (
                    <option key={index}>{element}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col>
                <Form.Select
                  className="form-control form-control-sm"
                  defaultValue={
                    patientItemSetting?.value?.properties?.banglaFontFamily
                  }
                  onChange={(e) =>
                    handlePatientInputSetting(
                      'value',
                      'properties',
                      'labelValue',
                      'banglaFontFamily',
                      e.target.value,
                    )
                  }
                >
                  {banglaFontFamilies?.map((element, index) => (
                    <option key={index}>{element}</option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
            <hr className="custom-hr" />
            <Row>
              <Col className="text-center">
                <Button variant="primary" size="sm" onClick={handleSubmit}>
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default memo(PatientSettingForm);
